"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALBUM_COMPARISON_EMBED = 'album_sample_comparison_embed';
exports.ALBUM_EMBED = 'album_embed';
exports.ALBUM_FEATURE_EMBED = 'album_feature_embed';
exports.ALBUM_GRID = 'album_grid';
exports.ALBUM_ROW_EMBED = 'album_row_embed';
exports.ALBUM_WITH_QUOTE_EMBED = 'album_with_quote_embed';
exports.APP_CALLOUT = 'app_callout';
exports.ARTICLE_SECTION = 'article_section';
exports.ARTIST_ROW = 'artist_row';
exports.BRAND_COLLECTION = 'brand_collection';
exports.CALL_TO_ACTION = 'call_to_action';
exports.CATEGORY_COLLECTION = 'category_collection';
exports.CATEGORY_SEARCH = 'category_search';
exports.CMS_PAGE_CARDS = 'cms_page_cards';
exports.COLLECTION_LISTINGS_ROW_EMBED = 'collection_listings_row_embed';
exports.CSP_COLLECTION = 'csp_collection';
exports.CSP_FEATURE = 'csp_feature';
exports.CURATED_SET_COLLECTION = 'curated_set_collection';
exports.EMAIL_SIGNUP_FORM = 'email_signup_form';
exports.FEED_ROW = 'feed_row';
exports.FULL_BLEED_HEADING = 'full_bleed_heading';
exports.GENRE_ROW = 'genre_row';
exports.HANDPICKED_LISTINGS_ROW_EMBED = 'handpicked_listings_row_embed';
exports.HANDPICKED_PAGE_ROWS = 'handpicked_page_rows';
exports.HEADING = 'heading';
exports.HOLIDAY_GRID = 'holiday_grid';
exports.IMAGE_EMBED = 'image_embed';
exports.IMAGE_FEATURE = 'image_feature';
exports.IMAGE_GALLERY = 'image_gallery';
exports.LINK_LIST = 'link_list';
exports.LISTINGS_COLLECTION = 'listings_collection';
exports.MARKDOWN_SECTION = 'markdown_section';
exports.MARKDOWN_TO_HTML_SECTION = 'markdown_to_html_section';
exports.MARKETING_CALLOUT = 'marketing_callout';
exports.MOSAIC = 'mosaic';
exports.PULLQUOTE = 'pullquote';
exports.RECENTLY_VIEWED_LISTINGS = 'recently_viewed_listings';
exports.RELEASE_EMBED = 'release_embed';
exports.REVIEW_LIST = 'review_list';
exports.SEO_BLURB = 'seo_blurb';
exports.SHOP_LISTINGS_ROW_EMBED = 'shop_listings_row_embed';
exports.SHOP_ROW_EMBED = 'shop_row_embed';
exports.SUBCATEGORY_NAV = 'subcategory_nav';
exports.VIDEO_EMBED = 'video_embed';
var CORE_COMPONENTS = [
    exports.ARTICLE_SECTION,
    exports.BRAND_COLLECTION,
    exports.CALL_TO_ACTION,
    exports.CATEGORY_COLLECTION,
    exports.CATEGORY_SEARCH,
    exports.CMS_PAGE_CARDS,
    exports.CSP_FEATURE,
    exports.CSP_COLLECTION,
    exports.CURATED_SET_COLLECTION,
    exports.FULL_BLEED_HEADING,
    exports.HEADING,
    exports.IMAGE_EMBED,
    exports.IMAGE_FEATURE,
    exports.IMAGE_GALLERY,
    exports.LINK_LIST,
    exports.LISTINGS_COLLECTION,
    exports.MARKETING_CALLOUT,
    exports.MARKDOWN_TO_HTML_SECTION,
    exports.PULLQUOTE,
    exports.RECENTLY_VIEWED_LISTINGS,
    exports.REVIEW_LIST,
    exports.SEO_BLURB,
    exports.SUBCATEGORY_NAV,
    exports.VIDEO_EMBED,
];
var LP_COMPONENTS = [
    exports.ALBUM_COMPARISON_EMBED,
    exports.ALBUM_EMBED,
    exports.ALBUM_FEATURE_EMBED,
    exports.ALBUM_GRID,
    exports.ALBUM_ROW_EMBED,
    exports.ALBUM_WITH_QUOTE_EMBED,
    exports.APP_CALLOUT,
    exports.ARTICLE_SECTION,
    exports.ARTIST_ROW,
    exports.CALL_TO_ACTION,
    exports.CATEGORY_SEARCH,
    exports.CMS_PAGE_CARDS,
    exports.COLLECTION_LISTINGS_ROW_EMBED,
    exports.CSP_COLLECTION,
    exports.CSP_FEATURE,
    exports.CURATED_SET_COLLECTION,
    exports.EMAIL_SIGNUP_FORM,
    exports.FEED_ROW,
    exports.FULL_BLEED_HEADING,
    exports.GENRE_ROW,
    exports.HANDPICKED_LISTINGS_ROW_EMBED,
    exports.HANDPICKED_PAGE_ROWS,
    exports.HEADING,
    exports.IMAGE_EMBED,
    exports.IMAGE_FEATURE,
    exports.IMAGE_GALLERY,
    exports.LINK_LIST,
    exports.LISTINGS_COLLECTION,
    exports.MARKDOWN_TO_HTML_SECTION,
    exports.MARKETING_CALLOUT,
    exports.MOSAIC,
    exports.PULLQUOTE,
    exports.RELEASE_EMBED,
    exports.SEO_BLURB,
    exports.SHOP_LISTINGS_ROW_EMBED,
    exports.SHOP_ROW_EMBED,
    exports.VIDEO_EMBED,
];
function getComponentsForChannel(channels) {
    if (channels.indexOf('lp') !== -1)
        return LP_COMPONENTS;
    return CORE_COMPONENTS;
}
exports.getComponentsForChannel = getComponentsForChannel;
//# sourceMappingURL=component_types.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/component_types.js
// module id = FKbu
// module chunks = 0 2 6 20